import { z } from 'zod';
import { GlobalState, UI } from '@leverege/ui-redux';
import { VALUE_KEY } from './CarMaxZoneSearch';
const validator = v => {
  const value = UI.get(GlobalState.get(), VALUE_KEY);
  if (value && value !== 'none' || v) {
    return true;
  }
  return false;
};
export default z.custom(validator);